exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable.day-wise-discount td {\n    padding: 2px 20px 4px 0px !important;\n}\ntable.day-wise-discount tr td.secound-discount {\n\twidth: 14%;\n}\n", ""]);

// exports
